export default "__VITE_ASSET__BktMIeLO__"